import { useEffect, useState } from 'react'
import { api } from '../api/client'
import './LeaderboardModal.css'

interface LeaderboardEntry {
  username: string
  best_survival_wave: number
  best_survival_score: number
}

interface Props {
  isOpen: boolean
  onClose: () => void
}

export default function LeaderboardModal({ isOpen, onClose }: Props) {
  const [data, setData] = useState<LeaderboardEntry[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (isOpen) {
      setLoading(true)
      api.getLeaderboard()
        .then(setData)
        .finally(() => setLoading(false))
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div className="leaderboard-overlay" onClick={onClose}>
      <div className="leaderboard-modal" onClick={e => e.stopPropagation()}>
        <header className="leaderboard-header">
          <h2>RANKING SURVIVAL</h2>
          <button className="leaderboard-close" onClick={onClose}>×</button>
        </header>

        <div className="leaderboard-content">
          {loading ? (
            <div className="leaderboard-loading">Carregando mestre...</div>
          ) : (
            <table className="leaderboard-table">
              <thead>
                <tr>
                  <th>Pos</th>
                  <th>Capoeirista</th>
                  <th>Onda</th>
                  <th>Score</th>
                </tr>
              </thead>
              <tbody>
                {data.map((entry, i) => (
                  <tr key={i} className={i < 3 ? `rank-${i + 1}` : ''}>
                    <td>{i + 1}º</td>
                    <td>{entry.username}</td>
                    <td>{entry.best_survival_wave}</td>
                    <td>{entry.best_survival_score.toLocaleString()}</td>
                  </tr>
                ))}
                {data.length === 0 && (
                  <tr>
                    <td colSpan={4} style={{ textAlign: 'center', padding: '40px' }}>
                      Nenhum recorde registrado ainda. Seja o primeiro!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  )
}
